<!--巡回日报  -->
<template>
	<div>
		<div class="info-box">
			<el-dialog
				title="订单录入"
				v-if="dialogVisible"
				:visible.sync="dialogVisible"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				:modal-append-to-body="false"
				width="1000px"
				:before-close="cancle"
				top="3vh"
			>
				<div>
					<el-form
						:inline="true"
						:model="ruleForm"
						:rules="rules"
						ref="ruleForm"
						label-width="100px"
						class="demo-ruleForm"
					>
						<el-form-item label="组织结构" prop="groupId">
							<el-select
								v-model="ruleForm.groupId"
								class="w190"
								placeholder="选择"
								@change="handleGroupId"
							>
								<el-option
									v-for="item in groupDate"
									:key="item.groupId"
									:label="item.groupName"
									:value="item.groupId"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="客商名称" prop="agentName">
							<el-input
								v-model.trim="ruleForm.agentName"
								class="w190"
								maxlength="16"
								readonly
								:disabled="ruleForm.groupId ? false : true"
							>
								<i
									slot="suffix"
									:class="
										!ruleForm.groupId ? 'nonallowed' : ''
									"
									@click="handleAddMerChant"
									class="el-input__icon el-icon-search"
								></i>
							</el-input>
						</el-form-item>
						<el-form-item label="客商SAP编号" prop="sapAgentNo">
							<el-input
								v-model.trim="ruleForm.sapAgentNo"
								class="w190"
								maxlength="16"
								readonly
								:disabled="true"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="订单类型" prop="orderType">
							<el-select
								v-model.trim="ruleForm.orderType"
								class="w190"
								placeholder="选择"
							>
								<!-- <el-option label="终端提交的配送订单" value="0"> -->
								<!-- </el-option> -->
								<el-option label="自销" value="1"> </el-option>
								<el-option label="第三方配送" value="2">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="结算方式" prop="settlementType">
							<el-select
								v-model.trim="ruleForm.settlementType"
								class="w190"
								placeholder="选择"
								:disabled="true"
							>
								<el-option label="现金" value="0"> </el-option>
								<el-option label="账期" value="1"> </el-option>
								<el-option label="自贩" value="9"> </el-option>
								<el-option label="其他" value="2"> </el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input
								v-model.trim="ruleForm.remark"
								type="textarea"
								:rows="2"
								class="w190"
							>
							</el-input>
						</el-form-item>
					</el-form>
					<div class="info-title flex flex-between">
						<div class="lh30">订单明细:</div>
						<div class="flex">
							<img
								class="icon-img ml7"
								src="@/assets/images/delete.png"
								@click="deleteRow"
								:class="ruleForm.agentId ? '' : 'not-allowed'"
								title="删除"
								alt=""
							/>
							<img
								class="icon-img ml7"
								src="@/assets/images/add.png"
								@click="handleAdd"
								:class="ruleForm.agentId ? '' : 'not-allowed'"
								title="新增"
								alt=""
							/>
						</div>
					</div>
					<el-table
						class="mt10"
						ref="multipleTable"
						:data="tableData"
						:header-cell-style="{
							background: 'rgba(200, 204, 215,.6)',
							color: '#333333'
						}"
						@selection-change="handleSelectionChange"
						border
						style="width: 100%"
					>
						<el-table-column
							type="selection"
							width="50"
							align="center"
						>
						</el-table-column>
						<el-table-column prop="skuName" label="SKU" width="180">
						</el-table-column>
						<el-table-column
							prop="productQuantity"
							label="数量"
							width="180"
						>
						</el-table-column>
						<el-table-column prop="storeName" label="出货仓">
						</el-table-column>
						<el-table-column prop="productDate" label="生产日期">
						</el-table-column>
						<el-table-column prop="skuPrice" label="单价">
						</el-table-column>
						<el-table-column prop="saleMoney" label="金额">
						</el-table-column>
					</el-table>
					<div class="info-title mt20">支付信息:</div>
					<div class="mt10">
						订单金额： {{ ruleForm.orderMoney || 0 }}
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="small" @click="cancle()">取 消</el-button>
					<el-button
						size="small"
						type="primary"
						@click="submitForm('ruleForm')"
						>确 定</el-button
					>
				</span>
			</el-dialog>
		</div>
		<!-- 添加客商 -->
		<addMerchants ref="addMerchants" @merchantsInfo="merchantsInfo"></addMerchants>
		<!-- 添加订单 -->
		<addOrder ref="addOrder" @rowData="getRowData"></addOrder>
	</div>
</template>

<script>
import addMerchants from "./add-merchants.vue";
import addOrder from "./add-order.vue";
import { debounce } from "@/utils/debounce";
// js进行数学运算存在精确度问题,引用Decimal数学运算库
import Decimal from 'decimal.js'
export default {
	components: {
		addMerchants,
		addOrder
	},
	data() {
		return {
			dialogVisible: false,
			groupDate: [],
			rowData: {},
			tableData: [],
			multipleSelection: [],
			ruleForm: {
				agentName: "",
				groupId: "",
				remark: "",
				orderType: "",
				sapAgentNo: "",
				settlementType: "",
				orderMoney: 0
			},
			rules: {
				agentName: [
					{
						required: true,
						message: "请选择客商名称"
						// trigger: 'change'
					}
				],
				groupId: [
					{
						required: true,
						message: "请选择组织结构",
						trigger: "change"
					}
				],
				orderType: [
					{
						required: true,
						message: "请选择订单类型",
						trigger: "change"
					}
				]
			},
			orderDetails: []
		};
	},
	created() {},
	methods: {
		init() {
			this.$nextTick(() => {
				this.dialogVisible = true;
				(this.ruleForm = {
					agentName: "",
					groupId: "",
					remark: "",
					orderType: "",
					sapAgentNo: "",
					settlementType: "",
					orderMoney: 0
				}),
				(this.tableData = []);
				this.getAgentSelectList();
			});
		},
		// 组织结构
		getAgentSelectList() {
			let that = this;
			that.$request.post("busSelectList", false, {}).then(res => {
				if (res) {
					that.groupDate = res.data;
				}
			});
		},
		// 添加客商订单
		handleAddMerChant() {
			this.$refs.addMerchants.init(this.ruleForm.groupId);
			this.tableData = [];
		},
		// 客商信息回调
		merchantsInfo(val) {
			// console.log(val)
			this.currentMerchants = val;
			this.ruleForm.agentId = val.agentId;
			this.ruleForm.agentName = val.agentName;
			this.ruleForm.sapAgentNo = val.sapNo;
			this.ruleForm.settlementType = val.settlementType;
		},
		// 订单回调
		getRowData(val) {
			this.tableData.push(val);
			// js进行数学运算存在精确度问题,引用Decimal数学运算库
			this.ruleForm.orderMoney = new Decimal(this.ruleForm.orderMoney).add(new Decimal(val.saleMoney));
		},
		// 列多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},

		// 新增
		handleAdd() {
			if (this.ruleForm.agentId) {
				this.$refs.addOrder.init(this.ruleForm);
			}
		},

		// 删除
		deleteRow() {
			let that = this;
			if (that.ruleForm.agentId) {
				if (that.multipleSelection.length == 0) {
					that.$message.error("请先选择需要删除的数据");
					return;
				}
				that.multipleSelection.forEach(ele => {
					that.tableData.forEach((item, index, arr) => {
						if (item.uuid == ele.uuid) {
							arr.splice(index, 1); //删除下标为i的元素
							// js进行数学运算存在精确度问题,引用Decimal数学运算库
							that.ruleForm.orderMoney = new Decimal(that.ruleForm.orderMoney).sub(new Decimal(item.saleMoney));
						}
					});
				});
				that.$forceUpdate();
			}
		},
		// 取消
		cancle() {
			this.dialogVisible = false;
		},
		// 保存
		submitForm: debounce(
			function() {
				let that = this;
				that.$refs["ruleForm"].validate(valid => {
					if (valid) {
						if (that.tableData.length == 0) {
							that.$message.error("请先录入订单明细");
							return;
						}
						that.$confirm("是否确认保存？", {
							confirmButtonText: "确定",
							cancelButtonText: "取消"
						})
							.then(() => {
								that.$request
									.post("orderAdd", false, {
										agentId: that.ruleForm.agentId,
										groupId: that.ruleForm.groupId,
										agentName: that.ruleForm.agentName,
										settlementType: that.ruleForm.settlementType,
										orderMoney: that.ruleForm.orderMoney,
										remark: that.ruleForm.remark,
										orderType: that.ruleForm.orderType,
										orderDetails: that.tableData
									})
									.then(res => {
										if (res) {
											that.dialogVisible = false;
											that.$message.success("保存成功！");
											that.$emit("getList");
										}
									});
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},
			1000,
			true
		),
		// 组织结构变更时清空所有数据
		handleGroupId() {
			console.log(this.ruleForm.groupId);
			this.ruleForm = {
				agentName: "",
				groupId: this.ruleForm.groupId,
				remark: "",
				orderType: "",
				sapAgentNo: "",
				settlementType: "",
				orderMoney: 0
			};
			this.tableData = [];
		}
	},
	beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.mb0 {
	margin-bottom: 0 !important;
}

.w90 {
	width: 110px;
}

.nc-box {
	padding: 10px;
	border-bottom: 1px solid #dcdfe6;
	color: #606266;
	font-size: 13px;
}

.mb10 {
	margin-bottom: 10px !important;
}

.w190 {
	width: 280px !important;
}

.info-box {
	/deep/ .el-dialog__body {
		// min-height: 455px;
		overflow-y: auto;
		padding: 20px 20px 10px;
	}
}

.info-title {
	background: #e5e5e5;
	color: #333;
	padding: 10px;
	box-sizing: border-box;
	font-size: 16px;
	font-weight: bold;

	img {
		vertical-align: bottom;
		display: block;
	}
}

.el-form-item {
	width: 420px;
}

.w330 {
	width: 330px;
}

.w420 {
	width: 420px !important;
	margin-right: 10px;
}

.info-name {
	display: inline-block;
	width: 140px;
	text-align: right;
}

.opeartion {
	font-size: 18px;
}

.lh30 {
	line-height: 30px;
}

.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 5px;
	}

	/deep/ td {
		padding: 5px;
	}
}

.nc-box {
	padding: 10px;
	border-bottom: 1px solid #dcdfe6;
	color: #606266;
	font-size: 13px;
}
.info-name {
	display: inline-block;
	width: 140px;
	text-align: right;
	color: #999;
}
.w100 {
	width: 500px !important;
}
.not-allowed {
	cursor: not-allowed;
	// pointer-events:none;
}
.el-icon-search {
	cursor: pointer;
}
.nonallowed {
	pointer-events: none;
}
</style>
